export const messages = {
  en: {
    staffPrivilege: {
      title: 'Staff Privilege Management',
      privilegeId: 'Privilege ID',
      privilegeName: 'Privilege Name',
      groupId: 'Group ID',
      groupName: 'Group Name',
      status: 'Status',
      operation: 'Operation',
      delete: 'Delete',
      treeStructure: 'Tree Structure',
      inUse: 'In Use',
      confirmDelete: 'Confirm Delete',
      deleteMessage: 'Are you sure to delete this privilege?',
      cancel: 'Cancel',
      confirm: 'Confirm'
    }
  },
  zh: {
    staffPrivilege: {
      title: '员工权限管理',
      privilegeId: '权限ID',
      privilegeName: '权限名称',
      groupId: '权限组ID',
      groupName: '权限组名称',
      status: '状态',
      operation: '操作',
      delete: '删除',
      treeStructure: '树形结构',
      inUse: '在用',
      confirmDelete: '确认删除',
      deleteMessage: '确定要删除此权限吗？',
      cancel: '取消',
      confirm: '确定'
    }
  }
}